// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1yWFR","additionalInfo":"AgreementModal_additionalInfo__uc_zR"};